import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { InfertileEggBaseService } from './infertileegg-base.service';

@Injectable()
export class InfertileEggService extends InfertileEggBaseService {
  constructor() {
    const http = inject(HttpClient);

    super(http);
  }
}
